export const USER_GENDER_TITLE: Record<string, string> = {
  MALE: "Male",
  FEMALE: "Female",
};
